import { useMutation } from '@tanstack/react-query';
import { serverRequest2 } from '../util/server_request';
import { extractErrorMessage } from './extractErrorMessage';
import { notifyUser } from '../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

export function useInstantClaimRequest() {
  return useMutation({
    mutationFn: async (claimData) => {
      try {
        const formData = new FormData();
        formData.append('policy_number', claimData.policyNumber);
        formData.append('Current_cash_value', claimData.currentCashValue);
        formData.append('claim_amount', claimData.claimAmount);
        formData.append('withdrawal_purpose', claimData.withdrawalPurpose);
        formData.append('claim_default_telcomethod', claimData.telecomMethod);
        formData.append('claim_default_momo_wallet', claimData.momoWallet);

        const result = await serverRequest2('POST', 'policy/instant-claim-request', formData);
        if (!result || !result.success) {
          // Handle message as object or string
          let message = result?.message || 'Failed to submit instant claim request';
          if (typeof message === 'object') {
            // Convert validation errors object to string
            const errors = [];
            Object.keys(message).forEach(key => {
              // Replace underscores with spaces for better readability
              const fieldLabel = key.replace(/_/g, ' ');
              if (Array.isArray(message[key])) {
                errors.push(`${fieldLabel}: ${message[key].join(', ')}`);
              } else {
                errors.push(`${fieldLabel}: ${message[key]}`);
              }
            });
            message = errors.join('. ') || 'Validation failed';
          }
          throw new Error(message);
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to submit instant claim request');
        notifyOnce("error", errorMessage, "Claim Error");
        throw new Error(errorMessage);
      }
    },
  });
}
